"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToJexlExpression = stringToJexlExpression;
const jexl_1 = __importDefault(require("./jexl"));
const compilationCache = {};
// revert function strings back to main, create a different file for
// jexlStrings.ts pass the jexl property of the pluginManager as a param
/**
 * compile a jexlExpression to a string
 *
 * @param str - string of code like `jexl:...`
 * @param options -
 */
function stringToJexlExpression(str, jexl) {
    const cacheKey = `nosig|${str}`;
    if (!compilationCache[cacheKey]) {
        const match = str.startsWith('jexl:');
        if (!match) {
            throw new Error('string does not appear to be in jexl format');
        }
        const code = str.split('jexl:')[1];
        const compiled = jexl
            ? jexl.compile(code)
            : (0, jexl_1.default)().compile(code);
        compilationCache[cacheKey] = compiled;
    }
    return compilationCache[cacheKey];
}
